"use client";

import { useState, useRef, useEffect } from "react";
import { useAdmin } from "@/lib/admin/context";
import { Icon } from "@/lib/icons/Icon";
import styles from "./NotificationsBell.module.css";

/**
 * 🔔 Notyfikacje — bell icon + badge (count nieprzeczytanych) + dropdown lista.
 *
 * Faza G MVP: data z mock'a w AdminProvider (pusty array). W Fazie F.5+
 * fetch z `GET /IRESTAPI/v1/INOTIFACTIONS_CONTROLLER/list` + polling co 60s
 * lub WebSocket subscription (jeśli backend wspiera).
 */
export function NotificationsBell() {
  const { notifications, t } = useAdmin();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  //Close on outside click
  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <button
        type="button"
        className={styles.bell}
        onClick={() => setOpen((v) => !v)}
        aria-label={t.topBar.notificationsBell.ariaLabel(notifications.unreadCount)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        <Icon name="bell" className={styles.icon} />
        {notifications.unreadCount > 0 && (
          <span className={styles.badge}>{notifications.unreadCount}</span>
        )}
      </button>

      {open && (
        <div className={styles.dropdown} role="menu">
          {notifications.recent.length === 0 ? (
            <div className={styles.empty}>{t.topBar.notificationsBell.emptyState}</div>
          ) : (
            <ul className={styles.list}>
              {notifications.recent.map((n) => (
                <li key={n.id} className={n.read ? styles.item : `${styles.item} ${styles.itemUnread}`}>
                  <strong>{n.title}</strong>
                  <p>{n.body}</p>
                  <time>{n.createdAt}</time>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
